export var AsyncOperationStatus;
(function (AsyncOperationStatus) {
    AsyncOperationStatus["Pending"] = "Pending";
    AsyncOperationStatus["Running"] = "Running";
    AsyncOperationStatus["Succeeded"] = "Succeeded";
    AsyncOperationStatus["Failed"] = "Failed";
    AsyncOperationStatus["Canceled"] = "Canceled";
})(AsyncOperationStatus || (AsyncOperationStatus = {}));
export function isAsyncOperationTerminal(status) {
    switch (status) {
        case AsyncOperationStatus.Pending:
        case AsyncOperationStatus.Running:
            return false;
        case AsyncOperationStatus.Succeeded:
        case AsyncOperationStatus.Failed:
        case AsyncOperationStatus.Canceled:
            return true;
        default: {
            const exhaustiveCheck = status;
            throw new Error(`Unhandled status: ${exhaustiveCheck}`);
        }
    }
}
export function asyncOperationPercentComplete(progress) {
    if (progress.total === null || progress.total <= 0) {
        return null;
    }
    const ratio = progress.completed / progress.total;
    return Math.max(0, Math.min(100, Math.round(ratio * 100)));
}
//# sourceMappingURL=async-operation.js.map